import {
    GET_SALARY_EARN_REQUEST,
    GET_SALARY_EARN_SUCCESS,
    GET_SALARY_EARN_FAILURE
} from "../const"

import {getSalaryEarn} from "../api"

export const request = () => ({ type: GET_SALARY_EARN_REQUEST })

const success = (earn) => ({
    type: GET_SALARY_EARN_SUCCESS,
    payload: { earn },
})

const failure = () => ({ type: GET_SALARY_EARN_FAILURE })


export const receiveSalaryEarnInfo = (user_id, params) => async (dispatch) => {
    dispatch(request())
    try {
        const {data: receiveSalaryEarnInfoData} = await getSalaryEarn(user_id, params)
        dispatch(success(receiveSalaryEarnInfoData))
    } catch (e) {
        console.log(e)
        dispatch(failure())
    }
}